export enum paymentType {
    OnSitePayment = 0,
    OnlinePayment = 1
}